import React from "react";
import Select, { components } from "react-select";
import PropTypes from "prop-types";
import AsyncSelect from "react-select/async";
import { withStyles } from "@material-ui/core/styles";
import NoSsr from "@material-ui/core/NoSsr";
import { theComponents, styles, selectStyles } from "./DropdownComponents";

import { I18nContext } from "../../I18nProvider";

class Autocomplete extends React.Component {
  static contextType = I18nContext;
  
  state = {
    data: this.props.data || [],
    inputValue: "",
    timeID: [],
  };

  UNSAFE_componentWillReceiveProps({ data, value }) {
    this.setState({ ...this.state.data, data });
  }

  handleChange = (name) => (value) => {
    if (value === "" || value === null) {
      this.props.handleChange(this.props.dataType, "");
    } else if (Array.isArray(value)) {
      this.props.handleChange(
        this.props.dataType,
        value[value.length - 1].value
      );
    } else if (value != null) {
      this.props.handleChange(this.props.dataType, value.label);
    }
  };

  handleMultiChange = (name) => (value) => {
    if (value != null) {
      let result = value.map((val) => val.label);
      this.props.handleChange(this.props.dataType, result);
    } else {
      this.props.handleChange(this.props.dataType, []);
    }
  };

  loadOptions = (inputValue, callback) => {
    let timeID = [...this.state.timeID];

    this.props.dataType === "associatedJobs"
      ? timeID.push(
          setTimeout(() => {
            callback(this.filterData(inputValue));
          }, 10000)
        )
      : setTimeout(() => {
          callback(this.filterDataLicensee(inputValue));
        }, 4000);

    this.setState({ timeID });

    for (var i = 0; i < this.state.timeID.length - 1; i++) {
      window.clearTimeout(this.state.timeID[i]);
    }
  };

  filterData = (inputValue) => {
    return this.state.data
      .map((option) => ({
        label: option.title,
        value: option.title,
        id: option.uid,
        isDisabled: option.title === "Loading..." ? true : false,
      }))
      .filter((i) => i.label.toLowerCase().includes(inputValue.toLowerCase()));
  };

  filterDataLicensee = (inputValue) => {
    return this.state.data
      .map((option) => ({
        label: option.title,
        id: option.uid,
        code: option.properties["licensee:licenseeCode"],
        path: option.path,
        isDisabled: option.title === "Loading..." ? true : false,
      }))
      .filter((i) => i.label.toLowerCase().includes(inputValue.toLowerCase()));
  };

  render() {
    const appText = this.context;
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <NoSsr>
          {this.props.dataType === "licensee" ? (
            <AsyncSelect
              classes={classes}
              components={theComponents}
              styles={selectStyles}
              defaultOptions
              value={
                this.props.value === null
                  ? null
                  : { label: this.props.value, value: this.props.value }
              }
              loadOptions={this.loadOptions}
              onInputChange={(i) => {
                this.setState({ inputValue: i });
                this.props.setFilterData(i);
              }}
              onChange={this.props.handleChange}
              placeholder=""
            />
          ) : this.props.dataType === "associatedJobs" ? (
            <AsyncSelect
              isMulti
              classes={classes}
              components={theComponents}
              styles={selectStyles}
              defaultOptions={this.state.data.map((option) => ({
                label: option.title,
                value: option.title,
                id: option.uid,
                isDisabled: option.title === "Loading..." ? true : false,
              }))}
              value={
                this.props.value.length === 0
                  ? null
                  : this.props.value.map((value) => ({
                      label: value,
                      value: value,
                    }))
              }
              loadOptions={this.loadOptions}
              onInputChange={(i) => {
                this.setState({ inputValue: i });
                this.props.setFilterData(i);
              }}
              onChange={this.props.handleChange}
              placeholder=""
            />
          ) : this.props.type === "single" &&
            this.props.mapVariable === "title" ? (
            <Select
              isMulti={this.props.isNotRequired}
              classes={classes}
              styles={selectStyles}
              defaultOptions
              options={
                !this.props.isLoading
                  ? Array.isArray(this.state.data)
                    ? this.state.data.map((suggestion) => ({
                        value: suggestion.title,
                        label: suggestion.title,
                        id: suggestion.uid,
                      }))
                    : []
                  : [
                      {
                        value: "Loading...",
                        label: [appText.T140],
                        isDisabled: true,
                      },
                    ]
              }
              components={theComponents}
              value={
                this.props.value === ""
                  ? null
                  : { value: this.props.value, label: this.props.value }
              }
              onChange={this.props.handleChange}
              placeholder=""
              isClearable={false}
            />
          ) : this.props.type === "single" &&
            this.props.mapVariable === "label" ? (
            <Select
              isMulti={this.props.isNotRequired}
              classes={classes}
              styles={selectStyles}
              options={
                !this.props.isLoading
                  ? this.state.data.map((suggestion) => ({
                      value: suggestion.label,
                      label: suggestion.label,
                      id: suggestion.id,
                    }))
                  : [
                      {
                        value: "Loading...",
                        label: [appText.T140],
                        isDisabled: true,
                      },
                    ]
              }
              components={theComponents}
              value={
                this.props.value === ""
                  ? null
                  : { label: this.props.value, value: this.props.value }
              }
              onChange={
                this.props.handleChange
              }
              placeholder=""
              isClearable={false}
            />
          ) : this.props.type === "multi" &&
            this.props.mapVariable === "label" ? (
            <Select
              isMulti
              classes={classes}
              styles={selectStyles}
              options={
                this.props.isLoading === false
                  ? this.state.data.map((suggestion) => ({
                      value: suggestion.label,
                      label: suggestion.label,
                      id: suggestion.id,
                    }))
                  : [
                      {
                        value: "Loading...",
                        label: [appText.T140],
                        isDisabled: true,
                      },
                    ]
              }
              components={theComponents}
              value={
                this.props.value === "" || this.props.value === null
                  ? []
                  : Array.isArray(this.props.value)
                  ? this.props.value.map((option) => ({
                      label: option,
                      value: option,
                    }))
                  : { label: this.props.value, value: this.props.value }
              }
              onChange={this.props.handleChange}
              placeholder=""
            />
          ) : this.props.type === "multi" &&
            this.props.mapVariable === "title" ? (
            <Select
              isMulti
              classes={classes}
              styles={selectStyles}
              options={
                this.props.isLoading === false
                  ? this.state.data.map((suggestion) => ({
                      value: suggestion.title,
                      label: suggestion.title,
                    }))
                  : [
                      {
                        value: "Loading...",
                        label: [appText.T140],
                        isDisabled: true,
                      },
                    ]
              }
              components={theComponents}
              value={
                this.props.value === "" || this.props.value === null
                  ? []
                  : Array.isArray(this.props.value)
                  ? this.props.value.map((option) => ({
                      label: option,
                      value: option,
                    }))
                  : { label: this.props.value, value: this.props.value }
              }
              onChange={this.handleMultiChange("multi")}
              placeholder=""
            />
          ) : null}
        </NoSsr>
      </div>
    );
  }
}

Autocomplete.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Autocomplete);
